import { render } from "./ShareAtom.vue?vue&type=template&id=180d861c&scoped=true"
import script from "./ShareAtom.vue?vue&type=script&lang=js"
export * from "./ShareAtom.vue?vue&type=script&lang=js"

import "./ShareAtom.vue?vue&type=style&index=0&id=180d861c&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180d861c"]])

export default __exports__